import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	productSettingsIncidentManagementMenuItemSpotlightHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	productSettingsIncidentManagementMenuItemSpotlightDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	productSettingsIncidentManagementMenuItemSpotlightActionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	productSettingsIncidentManagementMenuItemSpotlightHeading: {
		id: 'servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-heading',
		defaultMessage: 'Save time during incidents with templates',
		description:
			'Heading for spotlight message in product settings pages for menu item of incident management',
	},
	productSettingsIncidentManagementMenuItemSpotlightDescription: {
		id: 'servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-description',
		defaultMessage:
			'Create and customize email templates to save time and send consistent stakeholder notifications during incidents.',
		description:
			'Description for spotlight message in product settings pages for menu item of incident management',
	},
	productSettingsIncidentManagementMenuItemSpotlightActionLabel: {
		id: 'servicedesk-incident-management-settings.common.ui.setting-menu-onboarding.product-settings-incident-management-menu-item-spotlight-action-label',
		defaultMessage: 'OK',
		description:
			'CTA action label for spotlight message in product settings pages for menu item of incident management',
	},
});
export default messages;
